module.exports = __webpack_public_path__ + "img/avatar.95e0a019.jpg";